import { getLocale } from '@i18n';

const DEFAULT_CURRENCY = 'BRL';

export function getPlanCurrency(plan) {
  if (plan?.currency) {
    return String(plan.currency).toUpperCase();
  }

  const providerCode = String(plan?.provider?.code || plan?.provider || '').toLowerCase();

  if (providerCode === 'stripe') {
    return 'USD';
  }

  return DEFAULT_CURRENCY;
}

export function getPlanAmountCents(plan) {
  const currency = getPlanCurrency(plan);

  if (currency === 'USD' && Number.isFinite(Number(plan?.usd_price))) {
    return Number(plan.usd_price);
  }

  return Number(plan?.price || 0);
}

export function formatMoney(cents, currency = DEFAULT_CURRENCY, locale?: string) {
  const normalizedCurrency = String(currency || DEFAULT_CURRENCY).toUpperCase();
  const normalizedLocale = locale || getLocale() || (normalizedCurrency === 'BRL' ? 'pt-BR' : 'en-US');

  return new Intl.NumberFormat(normalizedLocale, {
    style: 'currency',
    currency: normalizedCurrency,
  }).format(Number(cents || 0) / 100);
}

export function formatPlanMoney(plan, locale) {
  return formatMoney(getPlanAmountCents(plan), getPlanCurrency(plan), locale);
}

export function getPlanValue(plan) {
  return getPlanAmountCents(plan) / 100;
}
